import axios from "axios";
import { get } from "lodash";
import Swal from "sweetalert2";
import {
    ADD_ON_PRICING,
    API_URL,
    FLOORPLAN_STYLES,
    SERVICE_PRICING,
} from "../../../Constants";
import history from "../../../utils/history";

const checkStyle = (formSchema) => {
    if (formSchema.style === "None" || formSchema.style === "") {
        if (formSchema.stype === "floorplan") {
            return {
                bool: false,
                status: "error",
                mssge: "Select floorplan to proceed",
            };
        } else {
            return {
                bool: false,
                status: "error",
                mssge: "Select style to proceed",
            };
        }
    } else {
        return { bool: true, status: "success" };
    }
};

const checkPropertyDetails = (formSchema) => {
    const propertyDetails = formSchema.propertyDetails;
    if (
        (propertyDetails.property_name === "" ||
            propertyDetails.property_name === undefined) &&
        formSchema.project_name === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter property name.",
        };
    }
    if (
        propertyDetails.property_address === "" ||
        propertyDetails.property_address === undefined
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter property address",
        };
    }
    return { bool: true, status: "success" };
};

const checkPropertyName = (formSchema) => {
    if (formSchema.project_name.length < 4) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid project name",
        };
    } else {
        return { bool: true, status: "success" };
    }
};

const checkTemplate = (formSchema) => {
    if (formSchema.template) {
        if (Object.keys(formSchema.template).length === 0) {
            return {
                bool: false,
                status: "error",
                mssge: "Please choose a template.",
            };
        } else {
            return { bool: true, status: "success" };
        }
    } else {
        return {
            bool: false,
            status: "error",
            mssge: "Please choose a template.",
        };
    }
};

const checkImgUploads = (formSchema) => {
    let totalImgs = formSchema.image_details.length;
    let minReq = Number(formSchema.template.noOfImagesRequired);
    let maxReq = Number(formSchema.template.noOfMaxImagesRequired);

    if (formSchema.template) {
        if (minReq === maxReq) {
            if (totalImgs > maxReq) {
                return {
                    bool: false,
                    status: "error",
                    mssge: `This template support ${maxReq} images only. Please remove ${totalImgs - maxReq
                        } image(s)`,
                };
            } else if (totalImgs < minReq) {
                return {
                    bool: false,
                    status: "error",
                    mssge: `This template requires ${maxReq} images. Please upload ${minReq - totalImgs
                        } more image(s)`,
                };
            }
        } else if (totalImgs < minReq || totalImgs > maxReq) {
            return {
                bool: false,
                status: "error",
                mssge: `Please upload between ${formSchema.template.noOfImagesRequired} to ${formSchema.template.noOfMaxImagesRequired} images to proceed.`,
            };
        }
        return { bool: true, status: "success" };
    } else {
        return {
            bool: false,
            status: "error",
            mssge: "Please choose a template.",
        };
    }
};

const checkUploads = (formSchema, imgCount = 1) => {
    if (formSchema.image_details.length < imgCount) {
        return {
            bool: false,
            status: "error",
            mssge: "Upload minimum 1 image to proceed.",
        };
    } else {
        return { bool: true, status: "success" };
    }
};

const checkPhotoDetails = (formSchema) => {
    const idlArr = formSchema.image_details;
    const erIndex = [];
    idlArr.map((obj, i) =>
        obj.room === ""
            ? erIndex.push(i + 1)
            : obj.room === "NA"
                ? erIndex.push(i + 1)
                : ""
    );
    if (erIndex.length > 0) {
        const erMsg = `Please select room type for image number ${erIndex.join(
            ", "
        )}.`;
        return { bool: false, status: "error", mssge: erMsg };
    } else {
        return { bool: true, status: "success" };
    }
};

const checkFloorplanDetails = (formSchema) => {
    const idlArr = formSchema.image_details;
    const erIndex = [];
    idlArr.map((obj, i) => (obj.story_level === "" ? erIndex.push(i + 1) : ""));
    if (erIndex.length > 0) {
        const erMsg = `Please select Story/level for floor Plan ${erIndex.join(
            ", "
        )}.`;
        return { bool: false, status: "error", mssge: erMsg };
    } else {
        return { bool: true, status: "success" };
    }
};

const checkRenovationService = (formSchema) => {
    const idlArr = formSchema.image_details;
    const erIndex = [];
    idlArr.map((obj, i) => {
        if (obj.services) {
            if (obj.services.length === 0) {
                erIndex.push(i + 1);
            }
        } else {
            erIndex.push(i + 1);
        }
    });
    if (erIndex.length > 0) {
        const erMsg = `Please select service for image number ${erIndex.join(
            ", "
        )}.`;
        return { bool: false, status: "error", mssge: erMsg };
    } else {
        return { bool: true, status: "success" };
    }
};

const validURL = (str) => {
    const pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
        "i"
    ); // fragment locator
    return !!pattern.test(str);
};

const checkWVForm = (formSchema) => {
    if (
        formSchema.stype === "single_property_website" &&
        (formSchema.style === "None" || formSchema.style === "")
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please select a template",
        };
    }
    const propertyDetails = formSchema.propertyDetails;
    if (propertyDetails) {
        if (propertyDetails.is_listing_url === "NO") {
            if (
                propertyDetails.property_name === "" ||
                propertyDetails.property_name === undefined
            ) {
                return {
                    bool: false,
                    status: "error",
                    mssge: "Please enter property name.",
                };
            }
            if (
                propertyDetails.property_address === "" ||
                propertyDetails.property_address === undefined
            ) {
                return {
                    bool: false,
                    status: "error",
                    mssge: "Please enter property address.",
                };
            }
            if (
                propertyDetails.property_description === "" ||
                propertyDetails.property_description === undefined
            ) {
                return {
                    bool: false,
                    status: "error",
                    mssge: "Please enter property description.",
                };
            }

            if (
                propertyDetails.user_contact_details.about_yourself === "" ||
                propertyDetails.user_contact_details.about_yourself ===
                undefined
            ) {
                return {
                    bool: false,
                    status: "error",
                    mssge: "Please enter about yourself.",
                };
            }

            return checkUploads(formSchema);
        } else {
            const contactDetails =
                formSchema.propertyDetails.user_contact_details;
            if (contactDetails) {
                if (
                    contactDetails.prop_listing_url === "" ||
                    !validURL(contactDetails.prop_listing_url)
                ) {
                    return {
                        bool: false,
                        status: "error",
                        mssge: "Please enter valid listing URL.",
                    };
                } else {
                    return { bool: true, status: "success" };
                }
            } else {
                return {
                    bool: false,
                    status: "error",
                    mssge: "Please enter valid listing URL.",
                };
            }
        }
    } else {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid listing URL.",
        };
    }
};

const validateFreeTrialForm = (formSchema) => {
    const styleResp = checkStyle(formSchema);
    if (styleResp.bool) {
        const upldResp = checkUploads(formSchema);
        if (upldResp.bool) {
            const phoDtl = checkPhotoDetails(formSchema);
            if (phoDtl.bool) {
                return true;
            } else {
                return phoDtl;
            }
        } else {
            return upldResp;
        }
    } else {
        return styleResp;
    }
};
const redirectToOrderSummary=async (history,orderId)=>{
    setTimeout(() => {
        history.push(`my-orders?order-id=${orderId}`);
    }, 2000);
}
const saveForm = async (formSchema, setIsError, setErrMssge) => {
    try {
        if (
            formSchema.stype === "single_property_website" ||
            formSchema.stype === "single_property_video" ||
            formSchema.stype === "video_maker"
        ) {
            await axios({
                method: "post",
                url: `${API_URL}/temp_order`,
                data: { ...formSchema, number_of_img: formSchema.stype === 'single_property_video' ? formSchema.number_of_img : 1 },
            });
        } else {
            await axios({
                method: "post",
                url: `${API_URL}/temp_order`,
                data: formSchema,
            });
        }
    } catch (err) {
        setIsError(true);
        if (err?.response?.status == '400' && formSchema.orderID) {
            setErrMssge(err?.response?.data?.message||'');
            await redirectToOrderSummary(history,formSchema.orderID);
            setIsError(false);
        }
        else{
            setErrMssge("Some error occurred. Try again!");
            setTimeout(() => {
                setIsError(false);
                setErrMssge("");
            }, 1);
        }
    }
};

const searchFTByUser = async (email) => {
    try {
        const resp = await axios({
            method: "get",
            url: `${API_URL}/staging/dashboard/searchFT?email=${email}`,
        });

        if (resp.data.status === "success") {
            return resp.data.data;
        } else {
            return null;
        }
    } catch (err) {
        console.log(err);
    }
};

const placeOrder = async (
    formSchema,
    setShowSuccess,
    setIsError,
    setErrMssge
) => {
    Swal.fire({
        title: "Submitting...",
        showConfirmButton: false,
        allowOutsideClick: false,
    });
    Swal.showLoading();
    try {
        await saveForm(formSchema, setIsError, setErrMssge);
        const resp = await axios({
            method: "post",
            url: `${API_URL}/staging/submit-order-v2`,
            data: { oid: formSchema.orderID },
        });
        if (resp.data.status === "success") {
            Swal.close();
            setShowSuccess(true);
            setTimeout(() => {
                setShowSuccess(false);
            }, 1);
            return true;
        } else {
            Swal.close();
            setIsError(true);
            setErrMssge("Some error occurred. Try again!");
            setTimeout(() => {
                setIsError(false);
                setErrMssge("");
            }, 1);
            return false;
        }
    } catch (err) {
        setIsError(true);
        if (err?.response?.status == '400' && formSchema.orderID) {
            await redirectToOrderSummary(history,formSchema.orderID);
        }
        else{
       
        setErrMssge("Some error occurred. Try again!");
        setTimeout(() => {
            setIsError(false);
            setErrMssge("");
        }, 1);
        return false;
    }
    }
};

const updateSummary = (
    formSchema,
    stype,
    setPrice,
    setImgAddOnCount,
    setImgAddOnPrice,
    isCpnApplied,
    couponDis,
    setCouponDis,
    setIsCpnApplied
) => {
    if (formSchema.number_of_img) {
        const imgNum = Number(formSchema.number_of_img) || 0;

        let amount = 0;
        let totalAmount = 0;
        let addOnPrice = 0;
        let totalAddOnCnt = 0;
        let imgAmount = 0;

        if (stype === "staging") {
            if (imgNum >= 8) {
                amount = 16;
                imgAmount = 16;
            } else {
                amount = SERVICE_PRICING.staging;
                imgAmount = SERVICE_PRICING.staging;
            }
        } else if (stype === "commercial_virtual_staging") {
            amount = SERVICE_PRICING.commercial_virtual_staging;
            imgAmount = SERVICE_PRICING.commercial_virtual_staging;
        } else if (stype === "virtual_renovation") {
            amount = SERVICE_PRICING.virtual_renovation;
            imgAmount = SERVICE_PRICING.virtual_renovation;
        } else if (stype === "image_enhancement") {
            amount = SERVICE_PRICING.image_enhancement;
            imgAmount = SERVICE_PRICING.image_enhancement;
        } else if (stype === "day_to_dusk") {
            amount = SERVICE_PRICING.day_to_dusk;
            imgAmount = SERVICE_PRICING.day_to_dusk;
        } else if (stype === "occupied_to_vacant") {
            amount = SERVICE_PRICING.occupied_to_vacant;
            imgAmount = SERVICE_PRICING.occupied_to_vacant;
        } else if (stype === "object_removal") {
            amount = SERVICE_PRICING.object_removal;
            imgAmount = SERVICE_PRICING.object_removal;
        } else if (stype === "floorplan") {
            if (formSchema.style !== "None") {
                amount = FLOORPLAN_STYLES[formSchema.style].price;
                imgAmount = FLOORPLAN_STYLES[formSchema.style].price;
            }
        } else if (stype === "360_virtual_tour") {
            amount = SERVICE_PRICING["360_virtual_tour"];
            imgAmount = SERVICE_PRICING["360_virtual_tour"];
        } else if (stype === "single_property_video") {
            amount = SERVICE_PRICING.single_property_video;
            imgAmount = SERVICE_PRICING.single_property_video;
        } else if (stype === "single_property_website") {
            amount = SERVICE_PRICING.single_property_website;
            imgAmount = SERVICE_PRICING.single_property_website;
        } else if (stype === "video_maker") {
            amount = SERVICE_PRICING.video_maker;
            imgAmount = SERVICE_PRICING.video_maker;
        }

        let imgAddonSum = {
            basic_editing: 0,
            clutter_removal: 0,
            occupied_to_vacant: 0,
            image_modification: 0,
        };
        let imgAddonCnt = {
            basic_editing: 0,
            clutter_removal: 0,
            occupied_to_vacant: 0,
            image_modification: 0,
        };

        if (formSchema.stype === "virtual_renovation") {
            imgAddonSum = {
                basic_editing: 0,
                clutter_removal: 0,
                occupied_to_vacant: 0,
                virtual_staging: 0,
            };

            imgAddonCnt = {
                basic_editing: 0,
                clutter_removal: 0,
                occupied_to_vacant: 0,
                virtual_staging: 0,
            };
        }

        if (formSchema.image_details) {
            formSchema.image_details.map((imgObj) => {
                if (imgObj.services) {
                    imgObj.services.map((ser) => {
                        amount += ADD_ON_PRICING[ser];
                        imgAmount += ADD_ON_PRICING[ser];
                    });
                }

                Object.entries(imgAddonCnt).map(([k, v]) => {
                    if (imgObj[k] === "true") {
                        imgAddonSum[k] += ADD_ON_PRICING[k];
                        imgAddonCnt[k]++;
                        totalAddOnCnt++;
                    }
                    return null;
                });
                return null;
            });
        }

        Object.entries(imgAddonSum).map(([k, v]) => {
            totalAmount += v;
            return null;
        });
        if (
            formSchema.add_ons &&
            formSchema.add_ons.property_website === "true"
        ) {
            totalAmount += ADD_ON_PRICING["property_website"];
            totalAddOnCnt++;
        }
        if (formSchema.add_ons && formSchema.add_ons.project_video === "true") {
            totalAmount += ADD_ON_PRICING["project_video"];
            totalAddOnCnt++;
        }
        if (formSchema.add_ons && formSchema.add_ons.siteplan === "true") {
            totalAmount += ADD_ON_PRICING["siteplan"];
            totalAddOnCnt++;
        }
        if (formSchema.isRapidDelivery === "YES") {
            if (formSchema.rapidTime && formSchema.rapidTime === "24hr") {
                amount += ADD_ON_PRICING.rapid_delivery;
                addOnPrice += imgNum * ADD_ON_PRICING.rapid_delivery;
                totalAddOnCnt += imgNum;
            } else if (
                formSchema.rapidTime &&
                formSchema.rapidTime === "12hr"
            ) {
                amount += ADD_ON_PRICING.super_rapid_delivery;
                addOnPrice += imgNum * ADD_ON_PRICING.super_rapid_delivery;
                totalAddOnCnt += imgNum;
            } else {
                amount += ADD_ON_PRICING.rapid_delivery;
                addOnPrice += imgNum * ADD_ON_PRICING.rapid_delivery;
                totalAddOnCnt += imgNum;
            }
        }

        addOnPrice += totalAmount;
        totalAmount += imgNum * amount;

        setImgAddOnCount(imgAddonCnt);
        setImgAddOnPrice(imgAddonSum);

        if (isCpnApplied) {
            setCouponDis(0);
            setIsCpnApplied(false);
        }

        if (formSchema.stype === "virtual_renovation") {
            setPrice({
                totalAmount: imgAmount + addOnPrice,
                addOnAmount: addOnPrice,
                addOnCount: totalAddOnCnt,
                imageAmount: imgAmount,
                imageCount: imgNum,
            });
        } else if (formSchema.stype === "single_property_website") {
            setPrice({
                totalAmount: SERVICE_PRICING.single_property_website,
                addOnAmount: addOnPrice,
                addOnCount: totalAddOnCnt,
                imageAmount: SERVICE_PRICING.single_property_website,
                imageCount: 1,
            });
        } else if (formSchema.stype === "single_property_video") {
            setPrice({
                totalAmount: SERVICE_PRICING.single_property_video + (formSchema.number_of_img > 30 && (Math.ceil((formSchema.number_of_img - 30) / 5)) * 5),
                addOnAmount: formSchema.number_of_img > 30 ? ((Math.ceil((formSchema.number_of_img - 30) / 5)) * 5) : addOnPrice,
                addOnCount: totalAddOnCnt,
                imageAmount: SERVICE_PRICING.single_property_video,
                imageCount: formSchema.number_of_img,
            });
        } else if (formSchema.stype === "video_maker") {
            setPrice({
                totalAmount: SERVICE_PRICING.video_maker,
                addOnAmount: addOnPrice,
                addOnCount: totalAddOnCnt,
                imageAmount: SERVICE_PRICING.video_maker,
                imageCount: 1,
            });
        } else {
            setPrice({
                totalAmount: totalAmount,
                addOnAmount: addOnPrice,
                addOnCount: totalAddOnCnt,
                imageAmount: imgAmount * imgNum,
                imageCount: imgNum,
            });
        }
    } else {
        setPrice({
            totalAmount: 0,
            addOnAmount: 0,
            addOnCount: 0,
            imageAmount: 0,
            imageCount: Number(formSchema.number_of_img),
        });
    }
};

const applyCoupon = async (
    formSchema,
    setCouponDis,
    couponDis,
    setErrMssge,
    setIsError,
    setIsCpnApplied,
    isCpnApplied,
    price,
    setPrice,
    coupon,
    setCoupon,
    setCoErr,
    setCoErrCode
) => {
    if (isCpnApplied) {
        setPrice({
            ...price,
            totalAmount: Number(price.totalAmount) + Number(couponDis),
        });
        setCouponDis(0);
        setIsCpnApplied(false);
        setCoupon("");
    } else {
        if (coupon === "") {
            if (setCoErr !== undefined) {
                // console.log('Here')
                setCoErr(true);
                setCoErrCode("Please enter valid coupon code!");
                setTimeout(() => {
                    setCoErrCode("");
                    setCoErr(false);
                }, 3000);
            } else {
                setIsError(true);
                setErrMssge("Please enter valid coupon code!");
                setTimeout(() => {
                    setIsError(false);
                    setErrMssge("");
                }, 1);
            }
        } else {
            try {
                const res = await axios({
                    method: "post",
                    url: `${API_URL}/coupon/check`,
                    data: {
                        code: coupon,
                        orderID: formSchema.orderID,
                    },
                });
                if (res.data.status === "success") {
                    setIsCpnApplied(true);
                    setPrice({
                        ...price,
                        totalAmount: Number(res.data.amount),
                    });
                    setCouponDis(Number(res.data.discount));
                } else {
                    if (setCoErr !== undefined) {
                        // console.log('Here')
                        setCoErr(true);
                        setCoErrCode(res.data.message);
                        setTimeout(() => {
                            setCoErrCode("");
                            setCoErr(false);
                        }, 3000);
                        setCoupon("");
                    } else {
                        setIsError(true);
                        setErrMssge(res.data.message);
                        setTimeout(() => {
                            setIsError(false);
                            setErrMssge("");
                        }, 1);
                    }
                    setIsCpnApplied(false);
                    setPrice({
                        ...price,
                        totalAmount:
                            Number(price.totalAmount) + Number(couponDis),
                    });
                    setCouponDis(0);
                }
            } catch (e) {
                if (setCoErr !== undefined) {
                    // console.log('Here')
                    setCoErr(true);
                    setCoErrCode("Some error occurred");
                    setTimeout(() => {
                        setCoErrCode("");
                        setCoErr(false);
                    }, 3000);
                } else {
                    setIsError(true);
                    setErrMssge("Some error occurred.");
                    setTimeout(() => {
                        setIsError(false);
                        setErrMssge("");
                    }, 1);
                }
                setIsCpnApplied(false);
                setPrice({
                    ...price,
                    totalAmount: Number(price.totalAmount) + Number(couponDis),
                });
                setCouponDis(0);
            }
        }
    }
};

const verifyZeroPayment = (
    coupon,
    formSchema,
    couponDis,
    price,
    isCpnApplied,
    setCurrentStep,
    setPbStep
) => {
    Swal.fire({
        title: "Woohoo!!",
        confirmButtonText: "Proceed.",
        text: "Your order is in the house. Click proceed to confirm.",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
            try {
                const resp = await axios({
                    method: "post",
                    url: `${API_URL}/payment/verify-zero-payment`,
                    data: {
                        code: coupon,
                        orderID: formSchema.orderID,
                    },
                });

                if (resp.data.status === "success") {
                    if (isCpnApplied) {
                        const res = await axios({
                            method: "post",
                            url: `${API_URL}/coupon/applied`,
                            data: {
                                code: coupon,
                                orderID: formSchema.orderID,
                                o_amt:
                                    Number(couponDis) +
                                    Number(price.totalAmount),
                                d_amt: price.totalAmount,
                            },
                        });

                        if (res.data.status === "success") {
                            setCurrentStep("successful");
                            setPbStep("successful");
                        } else {
                            console.log("Error");
                        }
                    } else {
                        setCurrentStep("successful");
                        setPbStep("successful");
                    }
                }
            } catch (err) {
                Swal.fire({
                    icon: "error",
                    title: "Unable to process your request.",
                });
            }
        },
        //  allowOutsideClick: () => !Swal.isLoading(),
        allowOutsideClick: false,
    });
};

const getPaymentDetails = async (
    isCpnApplied,
    setIsCpnApplied,
    price,
    setPrice,
    couponDis,
    setCouponDis,
    setIsLoaded,
    setIsError,
    setErrMssge,
    formSchema,
    coupon,
    setCurrentStep,
    setPbStep
) => {
    if (isCpnApplied) {
        try {
            const res = await axios({
                method: "post",
                url: `${API_URL}/coupon/apply`,
                data: {
                    code: coupon,
                    orderID: formSchema.orderID,
                },
            });

            if (res.data.status === "success") {
                setIsCpnApplied(true);
                setPrice({
                    ...price,
                    totalAmount: Number(res.data.amount),
                });
                setCouponDis(res.data.discount);
                if (Number(res.data.amount) === 0) {
                    verifyZeroPayment(
                        coupon,
                        formSchema,
                        couponDis,
                        price,
                        isCpnApplied,
                        setCurrentStep,
                        setPbStep
                    );
                    return true;
                } else {
                    setIsLoaded(true);
                }
            } else {
                setIsError(true);
                setErrMssge(res.data.message);
                setTimeout(() => {
                    setIsError(false);
                    setErrMssge("");
                }, 1);
                setIsCpnApplied(false);
                setPrice({
                    ...price,
                    totalAmount: Number(price.totalAmount) + Number(couponDis),
                });
                setCouponDis(0);
                setIsLoaded(false);
            }
        } catch (err) {
            console.log(err);
            setIsError(true);
            setErrMssge("Something went wrong");
            setTimeout(() => {
                setIsError(false);
                setErrMssge("");
            }, 1);
            setIsCpnApplied(false);
            setPrice({
                ...price,
                totalAmount: Number(price.totalAmount) + Number(couponDis),
            });
            setCouponDis(0);
            setIsLoaded(false);
        }
    } else {
        try {
            const res = await axios({
                method: "get",
                url: `${API_URL}/staging/get_payment_details/${formSchema.orderID}`,
            });
            if (res.data.status === "success") {
                setPrice({
                    ...price,
                    totalAmount: Number(res.data.data.amount),
                });
                if (Number(res.data.data.amount) === 0) {
                    verifyZeroPayment(
                        coupon,
                        formSchema,
                        couponDis,
                        price,
                        isCpnApplied,
                        setCurrentStep,
                        setPbStep
                    );
                } else {
                    setIsLoaded(true);
                }
            } else {
                setIsError(true);
                setErrMssge("Something went wrong!");
                setTimeout(() => {
                    setIsError(false);
                    setErrMssge("");
                }, 1);
                setIsLoaded(false);
            }
        } catch (err) {
            setIsError(true);
            setErrMssge("Something went wrong!");
            setTimeout(() => {
                setIsError(false);
                setErrMssge("");
            }, 1);
            setIsLoaded(false);
        }
    }
};

const checkJustListedDetails = (formSchema) => {
    if (
        !formSchema.videoDetails.videoDetails.propertyDetails.property_name ||
        formSchema.videoDetails.propertyDetails.property_name === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid property name.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.property_address ||
        formSchema.videoDetails.propertyDetails.property_address === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid property address.",
        };
    }

    // if (
    //     !formSchema.videoDetails.propertyDetails.property_description ||
    //     formSchema.videoDetails.propertyDetails.property_description === ""
    // ) {
    //     return {
    //         bool: false,
    //         status: "error",
    //         mssge: "Please enter valid property Description.",
    //     };
    // }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_bedroom ||
        formSchema.videoDetails.propertyDetails.no_of_bedroom === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no of bedroom",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_bathroom ||
        formSchema.videoDetails.propertyDetails.no_of_bathroom === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no of bathroom",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_garage ||
        formSchema.videoDetails.propertyDetails.no_of_garage === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no of garage.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.area ||
        formSchema.videoDetails.propertyDetails.area === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid area.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.price ||
        formSchema.videoDetails.propertyDetails.price === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid price.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.name ||
        formSchema.videoDetails.agentDetails.name === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid name.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.email ||
        formSchema.videoDetails.agentDetails.email === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid email.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.phone ||
        formSchema.videoDetails.agentDetails.phone === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid phone no.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.address ||
        formSchema.videoDetails.agentDetails.address === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter address.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.profile_photo ||
        formSchema.videoDetails.agentDetails.profile_photo === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please upload profile photo.",
        };
    }

    return { bool: true, status: "success" };
};

const checkJustSoldDetails = (formSchema) => {
    if (
        !formSchema.videoDetails.propertyDetails.property_name ||
        formSchema.videoDetails.propertyDetails.property_name === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid property name.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.property_address ||
        formSchema.videoDetails.propertyDetails.property_address === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid property address.",
        };
    }

    // if (
    //     !formSchema.videoDetails.propertyDetails.property_description ||
    //     formSchema.videoDetails.propertyDetails.property_description === ""
    // ) {
    //     return {
    //         bool: false,
    //         status: "error",
    //         mssge: "Please enter valid property Description.",
    //     };
    // }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_bedroom ||
        formSchema.videoDetails.propertyDetails.no_of_bedroom === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no of bedroom",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_bathroom ||
        formSchema.videoDetails.propertyDetails.no_of_bathroom === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no of bathroom",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_garage ||
        formSchema.videoDetails.propertyDetails.no_of_garage === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no of garage.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.area ||
        formSchema.videoDetails.propertyDetails.area === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid area.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.price ||
        formSchema.videoDetails.propertyDetails.price === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid price.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.name ||
        formSchema.videoDetails.agentDetails.name === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid name.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.email ||
        formSchema.videoDetails.agentDetails.email === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid email.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.phone ||
        formSchema.videoDetails.agentDetails.phone === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid phone no.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.address ||
        formSchema.videoDetails.agentDetails.address === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter address.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.profile_photo ||
        formSchema.videoDetails.agentDetails.profile_photo === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please upload profile photo.",
        };
    }
    return { bool: true, status: "success" };
};

const checkOpenHouseDetails = (formSchema) => {
    if (
        !formSchema.videoDetails.propertyDetails.property_name ||
        formSchema.videoDetails.propertyDetails.property_name === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid property name.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.property_address ||
        formSchema.videoDetails.propertyDetails.property_address === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid property address.",
        };
    }

    // if (
    //     !formSchema.videoDetails.propertyDetails.property_description ||
    //     formSchema.videoDetails.propertyDetails.property_description === ""
    // ) {
    //     return {
    //         bool: false,
    //         status: "error",
    //         mssge: "Please enter valid property Description.",
    //     };
    // }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_bedroom ||
        formSchema.videoDetails.propertyDetails.no_of_bedroom === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no. of bedroom",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_bathroom ||
        formSchema.videoDetails.propertyDetails.no_of_bathroom === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no. of bathroom",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_garage ||
        formSchema.videoDetails.propertyDetails.no_of_garage === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no. of garage.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.area ||
        formSchema.videoDetails.propertyDetails.area === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid area.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.price ||
        formSchema.videoDetails.propertyDetails.price === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid price.",
        };
    }
    if (
        !formSchema.videoDetails.propertyDetails.date ||
        formSchema.videoDetails.propertyDetails.date === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid date.",
        };
    }
    if (
        !formSchema.videoDetails.propertyDetails.time ||
        formSchema.videoDetails.propertyDetails.time === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid time.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.name ||
        formSchema.videoDetails.agentDetails.name === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid name.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.email ||
        formSchema.videoDetails.agentDetails.email === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid email.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.phone ||
        formSchema.videoDetails.agentDetails.phone === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid phone no.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.address ||
        formSchema.videoDetails.agentDetails.address === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter address.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.profile_photo ||
        formSchema.videoDetails.agentDetails.profile_photo === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please upload profile photo.",
        };
    }
    return { bool: true, status: "success" };
};

const checkClientTestimonialDetails = (formSchema) => {
    if (
        !formSchema.videoDetails.clientDetails.client_name ||
        formSchema.videoDetails.clientDetails.client_name === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid client name.",
        };
    }

    if (
        !formSchema.videoDetails.clientDetails.client_review ||
        formSchema.videoDetails.clientDetails.client_review === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid client review.",
        };
    }

    if (
        !formSchema.videoDetails.clientDetails.profile_photo ||
        formSchema.videoDetails.clientDetails.profile_photo === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please upload client profile photo.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.property_name ||
        formSchema.videoDetails.propertyDetails.property_name === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid property name.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.property_address ||
        formSchema.videoDetails.propertyDetails.property_address === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid property address.",
        };
    }

    // if (
    //     !formSchema.videoDetails.propertyDetails.property_description ||
    //     formSchema.videoDetails.propertyDetails.property_description === ""
    // ) {
    //     return {
    //         bool: false,
    //         status: "error",
    //         mssge: "Please enter valid property Description.",
    //     };
    // }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_bedroom ||
        formSchema.videoDetails.propertyDetails.no_of_bedroom === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no of bedroom",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_bathroom ||
        formSchema.videoDetails.propertyDetails.no_of_bathroom === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no of bathroom",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.no_of_garage ||
        formSchema.videoDetails.propertyDetails.no_of_garage === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid no of garage.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.area ||
        formSchema.videoDetails.propertyDetails.area === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid area.",
        };
    }

    if (
        !formSchema.videoDetails.propertyDetails.price ||
        formSchema.videoDetails.propertyDetails.price === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid price.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.name ||
        formSchema.videoDetails.agentDetails.name === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid name.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.email ||
        formSchema.videoDetails.agentDetails.email === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid email.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.phone ||
        formSchema.videoDetails.agentDetails.phone === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter valid phone no.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.address ||
        formSchema.videoDetails.agentDetails.address === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please enter address.",
        };
    }

    if (
        !formSchema.videoDetails.agentDetails.profile_photo ||
        formSchema.videoDetails.agentDetails.profile_photo === ""
    ) {
        return {
            bool: false,
            status: "error",
            mssge: "Please upload profile photo.",
        };
    }
    return { bool: true, status: "success" };
};

const validateVideoMakerForm = (form, formSchema) => {
    let errMsg = "";
    for (let section = 0; section < form.length; section++) {
        for (
            let row = 0;
            row < form[section].section.fields_in_row.length;
            row++
        ) {
            for (
                let field = 0;
                field < form[section].section.fields_in_row[row].fields.length;
                field++
            ) {
                let el = form[section].section.fields_in_row[row].fields[field];

                let validFeilds = el.formSchema.website.validate;

                let input = get(
                    formSchema.videoDetails,
                    el.formSchema.website.field_props["data-json_path"],
                    ""
                );

                for (let validKey in validFeilds) {
                    switch (validKey) {
                        case "is_required":
                            {
                                if (input === "" || input === undefined) {
                                    errMsg = `${el.formSchema.label_value} is required`;
                                }
                            }
                            break;
                        case "regex": {
                            let regExp = new RegExp(validFeilds[validKey], "i");

                            let correct = regExp.test(input);

                            if (!correct) {
                                errMsg = `Please enter valid ${el.formSchema.label_value}`;
                            }
                            break;
                        }
                        case "min": {
                            if (input.length < validFeilds[validKey]) {
                                errMsg = `The minimum required length for ${el.formSchema.label_value} is ${validFeilds[validKey]}`;
                            }
                            break;
                        }
                        case "max": {
                            if (input.length > validFeilds[validKey]) {
                                errMsg = `The maximum required length for ${el.formSchema.label_value} is ${validFeilds[validKey]}`;
                            }
                            break;
                        }
                        default:
                            break;
                    }
                    if (errMsg) {
                        // fireSwal("error", errMsg, 5000);
                        return {
                            bool: false,
                            status: "error",
                            mssge: errMsg,
                        };
                    }
                }
            }
        }
    }
    return { bool: true, status: "success" };
};

const checkPersonalBrandingDetails = () => { };

export {
    validateFreeTrialForm,
    checkStyle,
    checkUploads,
    checkPhotoDetails,
    saveForm,
    placeOrder,
    updateSummary,
    applyCoupon,
    getPaymentDetails,
    verifyZeroPayment,
    checkRenovationService,
    checkFloorplanDetails,
    checkPropertyDetails,
    checkWVForm,
    searchFTByUser,
    checkPropertyName,
    checkJustListedDetails,
    checkJustSoldDetails,
    checkOpenHouseDetails,
    checkClientTestimonialDetails,
    checkPersonalBrandingDetails,
    checkTemplate,
    checkImgUploads,
    validateVideoMakerForm,
    redirectToOrderSummary
};
